import Swiper from 'swiper';
import { Navigation, Autoplay} from 'swiper/modules';
import 'swiper/css';
import './style.css'
class PcAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.swiperContainer = this.querySelector('.pc-announcement-swiper-container');
    this.arrows = this.querySelectorAll('.pc-announcement-swiper-button');
    if(this.getAttribute('type') === 'slide') {
      this.initSwiper();
    }else {
      const speed = parseFloat(this.getAttribute('marquee-speed'))
      const parentSelector = this.querySelector('.pc-announcement-marquee');
      const clone = parentSelector.innerHTML;
      const firstElement = parentSelector.children[0];
      let i = 0;
      parentSelector.insertAdjacentHTML('beforeend', clone);
      parentSelector.insertAdjacentHTML('beforeend', clone);
    
      setInterval(function () {
        firstElement.style.marginLeft = `-${i}px`;
        if (i > firstElement.clientWidth) {
          i = 0;
        }
        i = i + speed;
      }, 1);
    }
  }

  initSwiper() {
    let swiperConfig = {
      modules: [Navigation,Autoplay],
      speed: parseInt(this.getAttribute('animation-delay')) || 800,
    };

    if(this.getAttribute('autoslide') === 'true') {
      swiperConfig.loop = true,
      swiperConfig.autoplay = {
        delay: parseInt(this.getAttribute('time-delay')) || 3000,
        disableOnInteraction: false,
        stopOnLastSlide: false,
        pauseOnMouseEnter: true
      }
    }
   
    if(this.arrows.length > 0) {
        swiperConfig.navigation = {
            nextEl: this.querySelector('.pc-announcement-swiper-button-next'),
            prevEl: this.querySelector('.pc-announcement-swiper-button-prev'),
        }
    }
    let carouselIntense = new Swiper(this.swiperContainer, swiperConfig);
  }
}

if (!window.customElements.get('pc-announcement-bar')) {
  window.customElements.define('pc-announcement-bar', PcAnnouncementBar);
}